import AcfHelper from "../../_acf";
import Slider from "../../utils/_slider";
import Breakpoints from "../../utils/_breakpoints";

const blockClass = 'solution-block';
const slidersClass = 'solution-slider';

const Solution = {};

Solution.blockName = "solutions";

Solution.init = () => {
    AcfHelper.handleInit(Solution.blockName, () => {
        Slider.init({
            slider: slidersClass,
            container: blockClass,
        }, {
            slidesPerView: 1.1,
            loop: false,
            breakpoints: {
                [Breakpoints.getValues().md]: {
                    slidesPerView: 2,
                },
                [Breakpoints.getValues().lg]: {
                    slidesPerView: 3.2,
                }
            }
        });
    });
};

Solution.init();
export default Solution;
